import React, { useEffect, useRef } from "react";
import Swal from "sweetalert2";
import printJS from "print-js";
// import { useAuth } from "hooks/useAuth";

const PrintAgentPenalty = ({ penalty, refetch, onSuccess, onError }) => {
  const printRef = useRef();
  // const { user } = useAuth();

  const handlePrint = () => {
    const printContent = printRef.current;
    if (!printContent) {
      Swal.fire("Error", "Print reference not found", "error");
      return;
    }

    Swal.fire({
      title: "Confirm Print",
      text: "Are you sure you want to print this agent penalty?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Print!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          printJS({
            printable: printContent.innerHTML,
            type: "raw-html",
            targetStyles: ["*"],
            onPrintDialogClose: () => {
              Swal.fire({
                title: "Printing",
                text: "Agent penalty notice is being processed...",
                icon: "success",
                timer: 1500,
                showConfirmButton: false,
              });

              if (onSuccess) {
                onSuccess();
              }

              if (refetch) {
                refetch();
              }
            },
          });
        } catch (error) {
          console.error("PrintJS Error:", error);
          Swal.fire("Error", "Failed to print agent penalty", "error");
          if (onError) {
            onError();
          }
        }
      } else {
        Swal.fire("Cancelled", "Printing cancelled", "info");
      }
    });
  };

  useEffect(() => {
    if (penalty) {
      handlePrint();
    }
  }, [penalty]);

  if (!penalty) {
    return (
      <button className="btn btn-sm btn-success" onClick={handlePrint}>
        Print Penalty
      </button>
    );
  }

  return (
    <div>
      <button className="btn btn-sm btn-success" onClick={handlePrint}>
        Print Penalty
      </button>
      <div ref={printRef} style={{ display: "none" }}>
        <style>
          {`
          @media print {
            body {
              font-family: 'Arial', sans-serif;
              width: 210mm;
              height: 297mm;
              padding: 20mm;
              margin: 0;
              background: white;
            }
            .certificate {
              text-align: center;
              width: 100%;
              border: 3px solid #dc3545;
              padding: 30px;
              background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
              position: relative;
            }
            .certificate-header {
              margin-bottom: 30px;
            }
            .logo {
              width: 80px;
              height: auto;
              margin-bottom: 20px;
            }
            .title {
              font-size: 28px;
              font-weight: bold;
              color: #dc3545;
              margin: 20px 0;
              text-transform: uppercase;
              letter-spacing: 2px;
            }
            .subtitle {
              font-size: 18px;
              color: #495057;
              margin: 15px 0;
              font-style: italic;
            }
            .content {
              margin: 40px 0;
              font-size: 16px;
              line-height: 1.6;
            }
            .highlight {
              font-size: 20px;
              font-weight: bold;
              color: #dc3545;
              margin: 20px 0;
              text-transform: uppercase;
            }
            .details {
              margin: 30px 0;
              font-size: 14px;
            }
            .details-table {
              width: 100%;
              border-collapse: collapse;
              margin: 20px 0;
            }
            .details-table td {
              padding: 8px 12px;
              border: 1px solid #dee2e6;
              background: white;
            }
            .details-table .label {
              font-weight: bold;
              background: #f8f9fa;
              width: 120px;
            }
            .signature-section {
              margin-top: 50px;
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
            }
            .signature-box {
              text-align: center;
              flex: 1;
            }
            .signature-line {
              border-top: 1px solid #000;
              width: 150px;
              margin: 40px auto 10px auto;
            }
            .footer {
              margin-top: 40px;
              font-size: 12px;
              color: #6c757d;
              border-top: 1px solid #dee2e6;
              padding-top: 20px;
            }
            .border-decoration {
              position: absolute;
              top: 10px;
              left: 10px;
              right: 10px;
              bottom: 10px;
              border: 2px solid #dc3545;
              pointer-events: none;
            }
          }
          `}
        </style>

        <div className="certificate">
          <div className="border-decoration"></div>

          {/* Header */}
          <div className="certificate-header">
            <img src="/Kuber.jpeg" alt="Kuber Logo" className="logo" />
            <div className="title">Penalty Notice</div>
            <div className="subtitle">Agent Performance Warning</div>
          </div>

          {/* Content */}
          <div className="content">
            <p>This notice is issued to</p>
            <div className="highlight">
              {penalty.agent?.name || "Agent Name"}
            </div>
            <p>
              for the following performance-related penalty:
            </p>
          </div>

          {/* Penalty Details */}
          <div className="details">
            <table className="details-table">
              <tbody>
                <tr>
                  <td className="label">Agent:</td>
                  <td>{penalty.agent?.name || "N/A"}</td>
                </tr>
                <tr>
                  <td className="label">Season:</td>
                  <td>{penalty.season?.name || "N/A"}</td>
                </tr>
                <tr>
                  <td className="label">Reason:</td>
                  <td>{penalty.reason}</td>
                </tr>
                <tr>
                  <td className="label">Penalty Points:</td>
                  <td>{penalty.penalty_points}</td>
                </tr>
                <tr>
                  <td className="label">Penalty Date:</td>
                  <td>
                    {new Date(penalty.penalty_date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </td>
                </tr>
                <tr>
                  <td className="label">Notice ID:</td>
                  <td>#{penalty.id}</td>
                </tr>
                {penalty.notes && (
                  <tr>
                    <td className="label">Notes:</td>
                    <td>{penalty.notes}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Signature Section */}
          <div className="signature-section">
            <div className="signature-box">
              <div className="signature-line"></div>
              <div>Authorized Signature</div>
              <div style={{ fontSize: "12px", marginTop: "5px" }}>
                {new Date().toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </div>
            </div>
            <div className="signature-box">
              <div className="signature-line"></div>
              <div>Agent Acknowledgment</div>
            </div>
          </div>

          {/* Footer */}
          <div className="footer">
            <p>
              <strong>KUBER BALI ADVENTURE</strong>
            </p>
            <p>
              Br. Bayad, Desa Melinggih Kelod, Payangan, Gianyar, Bali 80572
            </p>
            <p>Phone: +62 123 456 789 | Email: info@kuberbali.com</p>
            <p style={{ marginTop: "10px", fontSize: "10px" }}>
              This penalty notice is automatically generated and serves as official documentation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintAgentPenalty;
